import 'jquery-ui/ui/widgets/slider';
import 'selectize';
import AddToCartButton from "./AddToCartButton";
import AddToWishlistButton from "./AddToWishlistButton";

export default (function (w, d) {
    'use strict';

    let that;

    function Filter() {
        that = this;
        this.openBtn = d.querySelector('.filters-open-btn');
        this.closeBtn = d.querySelector('.filters-close-btn');
        this.filterCloseBtns = d.querySelectorAll('.filter-close-btn');
        this.sliderElement = d.querySelector('.filter-price-slider');
        this.form = d.querySelector('.filter-form');
        this.formSubmitBtn = this.form.querySelector('.filter-submit-btn');
        this.formClearBtn = this.form.querySelector('.filter-form-clear-btn');
        this.filtersBlock = d.querySelector('.filters');
        this.productBlock = d.querySelector('.category-products');
        this.productCounterBlocks = d.querySelectorAll('.category-product-count-counter');
        this.pageIdentifierBlock = d.querySelector('.category-page-identifier');
        this.priceFromInput = this.form.querySelector('.filter-price-from');
        this.priceToInput = this.form.querySelector('.filter-price-to');
        this.sortSelectize = d.querySelector('.category-sort-selectize');
        this.brandSearchInput = d.querySelector('.filter-brand-search-input');
        this.brandBlock = d.querySelector('.filter-brand-block');
        this.init();
    }

    Filter.prototype.init = function () {
        this.initOpenBtn();
        this.initCloseBtn();
        this.initFilterCloseBtns();
        this.initPriceSlider();
        this.initFilterCollapseToggles();
        this.initFormSubmitBtn();
        this.initFormClearBtn();
        this.loadFilterValuesFromURL();
        this.initPageIdentifierAnchorClicks();
        this.initSortSelectize();
        this.initSortChange();
        this.initBrandSearchInput();
        this.initDiscountChecks();
    }

    Filter.prototype.initOpenBtn = function () {
        if (this.openBtn !== undefined) {
            $(this.openBtn).off().on('click', () => {
                this.openBtn.parentElement.querySelector('.filters-content').classList.add('open');
                d.body.classList.add('no-scroll');
            });
        }
    }

    Filter.prototype.initCloseBtn = function () {
        if (this.closeBtn !== undefined) {
            $(this.closeBtn).off().on('click', () => {
                this.openBtn.parentElement.parentElement.querySelector('.filters-content').classList.remove('open');
                d.body.classList.remove('no-scroll');
            });
        }
    }

    Filter.prototype.initFilterCloseBtns = function () {
        if (this.filterCloseBtns !== undefined) {
            $(this.filterCloseBtns).off().on('click', (elem) => {
                $(elem.target).closest('.filter').removeClass('extended');
            });
        }
    }

    Filter.prototype.initPriceSlider = function () {
        if (this.sliderElement !== undefined) {
            const sliderValues = this.sliderElement.dataset;

            $(this.sliderElement).slider({
                range: true,
                min: sliderValues.min,
                max: sliderValues.max / 10,
                values: [
                    sliderValues.min,
                    sliderValues.max,
                ],
                slide: function (event, ui) {
                    for (let i = 0; i < ui.values.length; ++i) {
                        $("input.filter-price-input[data-index=" + i + "]").val(ui.values[i] + ' €');
                    }
                },
            });

            $('input.filter-price-input').off().on('input', function () {
                const input = $(this);
                $(that.sliderElement).slider('values', input.data('index'), input.val().replace('€', ''));
            });
        }
    }

    Filter.prototype.initFilterCollapseToggles = function () {
        const filterHeaders = d.querySelectorAll('.filter-header');
        if (filterHeaders !== null) {
            filterHeaders.forEach(header => {
                $(header).off().on('click', () => {
                    document.querySelectorAll('.filter').forEach(elem => {
                        if (elem !== header.parentElement)
                            elem.classList.remove('extended');
                    });
                    header.parentElement.classList.toggle('extended');
                });
            });
        }
    }

    Filter.prototype.initDiscountChecks = function () {
        $('input.filter-discount').off().on('click', function () {
            $('input.filter-discount').not(this).prop('checked', false);
        });
    }

    Filter.prototype.initFormSubmitBtn = function () {
        if (this.formSubmitBtn !== undefined) {
            $(this.formSubmitBtn).off().on('click', (e) => {
                e.preventDefault();

                const url = new URL(w.location);
                let selectedFilterValues = {};

                // selectedFilterValues.sort = this.sortSelectize.data('selectize').getValue();
                selectedFilterValues.sort = this.getCheckboxValues('sort');
                selectedFilterValues.brand = this.getCheckboxValues('brand');
                selectedFilterValues.condition = this.getCheckboxValues('condition');
                selectedFilterValues.size = this.getCheckboxValues('size');
                selectedFilterValues.color = this.getCheckboxValues('color');
                selectedFilterValues.warehouse_status = this.getCheckboxValues('warehouse_status');
                selectedFilterValues.return_status = this.getCheckboxValues('return_status');
                selectedFilterValues.discount_up_to = this.getCheckboxValues('discount_30')
                    || this.getCheckboxValues('discount_40')
                    || this.getCheckboxValues('discount_50')
                    || this.getCheckboxValues('discount_70');
                selectedFilterValues.price_from = this.priceFromInput.value.replace('€', '').replace(' ', '');
                selectedFilterValues.price_to = this.priceToInput.value.replace('€', '').replace(' ', '');

                for (const [key, value] of Object.entries(selectedFilterValues)) {
                    if (value !== '') {
                        url.searchParams.set(key, value);
                        continue;
                    }

                    url.searchParams.delete(key);
                }

                url.searchParams.delete('page');

                this.loadProducts(url);

                this.openBtn.parentElement.parentElement.querySelector('.filters-content').classList.remove('open');
                d.body.classList.remove('no-scroll');
            });
        }
    }

    Filter.prototype.initFormClearBtn = function () {
        if (this.formClearBtn !== undefined) {
            $(this.formClearBtn).off().on('click', function (e) {
                e.preventDefault();

                $(this.form).find('input:checked').prop('checked', false);

                let url = new URL(w.location);

                that.loadProducts(url.origin + url.pathname);
            });
        }
    }

    Filter.prototype.getCheckboxValues = function (inputName = '') {
        if (inputName !== '') {
            return $(this.form).find('input[name="' + inputName + '"]:checked').map(function () {
                return this.value;
            }).get().join('-');
        }
    }

    Filter.prototype.loadFilterValuesFromURL = function () {
        let url = new URL(w.location);

        url.searchParams.forEach((value, key) => {
            let values = value.split('-');

            values.forEach(value => {
                const name = key === 'discount_up_to' ? 'discount_' + value : key;
                const input = this.form.querySelector('input[name="' + name + '"][value="' + value + '"]');
                if (input !== null) {
                    input.checked = true;

                    // let filterBlock = input.closest('.filter');
                    // if (!filterBlock.classList.contains('extended')) {
                    //     filterBlock.classList.add('extended');
                    // }
                }

                if (key === 'price_from') {
                    this.priceFromInput.value = value + ' €';
                    this.priceFromInput.dispatchEvent(new Event('input'));
                }

                if (key === 'price_to') {
                    this.priceToInput.value = value + ' €';
                    this.priceToInput.dispatchEvent(new Event('input'));
                }
            });
        });
    }

    Filter.prototype.initPageIdentifierAnchorClicks = function () {
        if (this.pageIdentifierBlock !== undefined) {
            $(this.pageIdentifierBlock).off().on('click', function (e) {
                e.preventDefault();

                let url;

                if (e.target.href !== undefined) {
                    url = e.target.href;
                } else {
                    url = e.target.closest('a').href;
                }

                if (url !== undefined) {
                    that.loadProducts(url);
                }
            });
        }
    }

    Filter.prototype.loadProducts = function (url = '') {
        this.productBlock.classList.add('spinner');

        $('html, body').animate({
            scrollTop: $('.filter-panel').offset().top - 20,
        }, 500);

        $.ajaxSetup({ cache: false });
        $.ajax({
            url: url,
            method: 'GET',
            success: function (data) {
                that.productBlock.innerHTML = data.product_list_html;
                that.productCounterBlocks.forEach(elem => {
                    elem.innerHTML = data.products_total;
                });
                that.pageIdentifierBlock.innerHTML = data.page_identifier_html;
                that.filtersBlock.innerHTML = data.filters_html;
                that.productBlock.classList.remove('spinner');

                w.history.pushState({}, '', url);

                new Filter();
                new AddToCartButton();
                new AddToWishlistButton();
            }
        });
    }

    Filter.prototype.initSortSelectize = function () {
        if (this.sortSelectize !== undefined) {
            this.sortSelectize = $(this.sortSelectize).selectize({
                onChange: function () {
                    that.formSubmitBtn.click();
                }
            });
        }
    }

    Filter.prototype.initSortChange = function () {
        $('input[name="sort"]').off().on('change', function () {
            that.formSubmitBtn.click();
        });
    }

    Filter.prototype.initBrandSearchInput = function () {
        $(this.brandSearchInput).off().on('input', () => {
            const inputValue = this.brandSearchInput.value;
            const brandLabels = this.brandBlock.querySelectorAll('label');
            brandLabels.forEach(label => {
                // remove ',', '.', '+', ''' from brand name
                const labelText = label.innerHTML.replace(/[,.+']/g, '');

                if (!labelText.toLowerCase().includes(inputValue)) {
                    label.parentElement.style.display = 'none';
                } else {
                    label.parentElement.style.display = 'block';
                }
            });
        });
    }

    return Filter;
}(window, document));

